
import React, { Component } from "react";
import App from "../../App";


import { IAudioManagerProps } from './IAudioManagerProps';
import { TAudioManagerState } from './TAudioManagerState';

import silence from "./../../sons/silence.mp3";
import arrivee from "./../../sons/arrivee.mp3";
import coffre_apparait from "./../../sons/coffre_apparait.mp3";
import coffre_disparait from "./../../sons/coffre_disparait.mp3";
import ouvrir_question from "./../../sons/ouvrir_question.mp3";
import bonne_rep from "./../../sons/bonne_rep.mp3";
import mauvaise_rep from "./../../sons/mauvaise_rep.mp3";
import ecus_1 from "./../../sons/ecus_1.mp3";
import ecus_2 from "./../../sons/ecus_2.mp3";
import ecus_3 from "./../../sons/ecus_3.mp3";
import escaliers from "./../../sons/escaliers.mp3";
import fin_partie from "./../../sons/fin_partie.mp3";


class AudioManager extends Component<IAudioManagerProps,any> {

  app:App;
  togglePlayer:boolean = false;
  
  constructor(props:any){
    super(props);
    this.app = props.app;
  }

  state:TAudioManagerState = this.getInitialState();
  getInitialState():TAudioManagerState{
    return{
      isInit:false
    }
  }

  componentDidMount(){      
    this.setState({isInit:true});

  }

  public play(son:string){
    
    const audioElTarget = document.getElementsByClassName(`audio-${son}`)[0] as HTMLAudioElement;
    const audioElTargetVolume = audioElTarget.getAttribute("data-volume");
    const volume = (audioElTargetVolume) ? Number(audioElTargetVolume) : 1;
    
    var audioGeneralPlayer;
    this.togglePlayer = !this.togglePlayer;
    if (this.togglePlayer){
      audioGeneralPlayer = document.getElementsByClassName(`audio-general-player-1`)[0] as HTMLAudioElement;
    } else {
      audioGeneralPlayer = document.getElementsByClassName(`audio-general-player-2`)[0] as HTMLAudioElement;
    }
    audioGeneralPlayer.autoplay = true;
    audioGeneralPlayer.src = audioElTarget.getAttribute("data-mysrc") || "";
    audioGeneralPlayer.volume = volume;

  }
  
  render() {
    
    return (
        <div className="audio">          
          <audio className="audio-general-player-1" preload="true">
            <source type="audio/mp3"></source>
          </audio>        
          <audio className="audio-general-player-2" preload="true">
            <source type="audio/mp3"></source>
          </audio>
          {/* Son silencieux joué sur le clic du popup d'intro afin d'actuver l'autoplay sur certains appareils */}
          <audio className="audio-silence" preload="true" data-mysrc={silence}>
            <source type="audio/mp3" src={silence} ></source>
          </audio>
          
          {/* Bruit pour l'arrivée dans un dongeon */}
          <audio className="audio-arrivee" preload="true" data-mysrc={arrivee}>
            <source type="audio/mp3" src={arrivee} ></source>
          </audio>
          {/* Bruit pour l'apparition d'un coffre */}
          <audio className="audio-coffre_apparait" data-volume="0.2" preload="true" data-mysrc={coffre_apparait}>
            <source type="audio/mp3" src={coffre_apparait} ></source>
          </audio>
          {/* Bruit pour disparition d'un coffre */}
          <audio className="audio-coffre_disparait" preload="true" data-mysrc={coffre_disparait}>
            <source type="audio/mp3" src={coffre_disparait} ></source>
          </audio>
          {/* Bruit pour l'ouverture des questions */}
          <audio className="audio-ouvrir_question" preload="true" data-mysrc={ouvrir_question}>
            <source type="audio/mp3" src={ouvrir_question} ></source>
          </audio>
          {/* Bruit pour bonne reponse */}
          <audio className="audio-bonne_rep" preload="true" data-mysrc={bonne_rep}>
            <source type="audio/mp3" src={bonne_rep} ></source>
          </audio>
          {/* Bruit pour mauvaise reponse */}
          <audio className="audio-mauvaise_rep" preload="true" data-mysrc={mauvaise_rep}>
            <source type="audio/mp3" src={mauvaise_rep} ></source>
          </audio>
          {/* Bruit pour 1-3 ecus */}
          <audio className="audio-ecus_1" preload="true" data-mysrc={ecus_1}>
            <source type="audio/mp3" src={ecus_1} ></source>
          </audio>
          {/* Bruit pour 4-7 ecus */}
          <audio className="audio-ecus_2" preload="true" data-mysrc={ecus_2}>
            <source type="audio/mp3" src={ecus_2} ></source>
          </audio>
          {/* Bruit pour 7+ ecus */}
          <audio className="audio-ecus_3" preload="true" data-mysrc={ecus_3}>
            <source type="audio/mp3" src={ecus_3} ></source>
          </audio>
          {/* Bruit pour fin de partie (descendre les esacliers) */}
          <audio className="audio-escaliers" data-volume="0.3" preload="true" data-mysrc={escaliers}>
            <source type="audio/mp3" src={escaliers} ></source>
          </audio>
          {/* Bruit pour fin de partie (dévoilement du titre) */}
          <audio className="audio-fin_partie" data-volume="0.5" preload="true" data-mysrc={fin_partie}>
            <source type="audio/mp3" src={fin_partie} ></source>
          </audio>
        </div>
    )
  }
}

export default AudioManager;
